"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readRevisionHistory = readRevisionHistory;
const revision_version_js_1 = require("./revision-version.js");
const revision_diff_js_1 = require("./revision-diff.js");
const revision_gating_js_1 = require("./revision-gating.js");
function applyV2ToSnapshot(live, meta) {
    const deleted = new Set(meta.milestonesDeleted.map((item) => item.id));
    const byId = new Map(live.milestones.filter((milestone) => !deleted.has(milestone.id)).map((milestone) => [milestone.id, { ...milestone }]));
    for (const change of meta.milestoneChanges) {
        const current = byId.get(change.id);
        if (!current)
            continue;
        byId.set(change.id, {
            ...current,
            name: change.fields.name ?? current.name,
            description: change.fields.description === undefined ? current.description : change.fields.description,
            startDate: change.fields.startDate === undefined ? current.startDate : change.fields.startDate,
            endDate: change.fields.endDate === undefined ? current.endDate : change.fields.endDate,
        });
    }
    const milestones = [
        ...byId.values(),
        ...meta.milestonesAdded.map((added) => ({
            id: added.tempId,
            name: added.name,
            description: added.description,
            budgetAmount: added.budgetAmount,
            startDate: added.startDate,
            endDate: added.endDate,
        })),
    ];
    const deletedInvoices = new Set(meta.invoiceChanges.filter((change) => change.delete && change.id).map((change) => change.id));
    const invoices = [
        ...live.invoices
            .filter((invoice) => !deletedInvoices.has(invoice.id))
            .map((invoice) => {
            const change = meta.invoiceChanges.find((item) => item.id === invoice.id);
            return {
                id: invoice.id,
                milestoneIds: change?.milestoneIds ?? invoice.milestoneIds,
            };
        }),
        ...meta.invoiceChanges
            .filter((change) => change.isNew || change.tempId)
            .map((change) => ({
            id: change.tempId || change.id || "new",
            milestoneIds: change.milestoneIds ?? [],
        })),
    ];
    return {
        schemaVersion: 2,
        milestones: milestones.map((milestone) => ({
            id: milestone.id,
            name: milestone.name,
            description: milestone.description,
            budgetAmount: "budgetAmount" in milestone ? Number(milestone.budgetAmount ?? 0) : undefined,
            startDate: milestone.startDate,
            endDate: milestone.endDate,
        })),
        invoices,
        projectStartDate: meta.projectStartDate ?? (0, revision_gating_js_1.toDateOnly)(live.startDate),
        projectEndDate: meta.projectEndDate ?? (0, revision_gating_js_1.toDateOnly)(live.endDate),
        rounds: meta.rounds,
    };
}
function readV1History(metadata) {
    const originals = metadata?.originalMilestones?.length ? metadata.originalMilestones : metadata?.milestonesRevision;
    const originalInvoices = metadata?.originalInvoices?.length
        ? metadata.originalInvoices.map((invoice) => ({
            id: invoice.id,
            milestoneIds: (invoice.projectMilestones ?? []).map((item) => item.id),
        }))
        : (metadata?.invoicesRevision ?? []).filter((invoice) => invoice.id).map((invoice) => ({
            id: invoice.id,
            milestoneIds: invoice.milestoneIds ?? [],
        }));
    return {
        schemaVersion: 1,
        milestones: (originals ?? [])
            .filter((milestone) => milestone.id)
            .map((milestone) => ({
            id: milestone.id,
            name: milestone.name,
            description: milestone.description,
            budgetAmount: Number(milestone.budgetAmount ?? 0),
            startDate: milestone.startDate,
            endDate: milestone.endDate,
        })),
        invoices: originalInvoices,
        projectStartDate: metadata?.originalProjectStartDate ?? metadata?.projectStartDate ?? null,
        projectEndDate: metadata?.originalProjectEndDate ?? metadata?.projectEndDate ?? null,
    };
}
function readRevisionHistory(input) {
    if ((0, revision_version_js_1.getRevisionSchemaVersion)(input) === 2 && input.metadata) {
        const live = input.live ?? { milestones: [], invoices: [], adjustments: [] };
        return applyV2ToSnapshot(live, (0, revision_diff_js_1.normalizeRevisionV2Metadata)(input.metadata));
    }
    return readV1History(input.metadata ?? null);
}
